import Vue from "vue";

export default {
  fetchEmployeeHomeDetails() {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/home/admin")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchRecentActivities() {
    return Vue.$http.get("/home/admin/recent-activities");
  },
  getAllApprovers({ state, commit }, getApiUrl) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      const searchQuery = state.searchQuery;
      const params = {
        page: state.pageApprover,
        per_page: state.perPageApprover,
        ...(searchQuery && { search_query: searchQuery }),
      };

      Vue.$http
        .get(getApiUrl, { params })
        .then(response => {
          commit("tableLoading", false);
          commit("allApprovers", response.data.results);
          commit("approversTotal", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  createApprover(_, { data, createApiUrl }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(createApiUrl, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getApproverById(_, { id, getOneApiUrl }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`${getOneApiUrl}/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  deleteApprover(_, { id, deleteApiUrl }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`${deleteApiUrl}/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  assignEmployeeToApproval(_, { data, id, assignableApiUrl }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          `${assignableApiUrl}/${id}/approvables
`,
          data
        )
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getApprovables(_, { id, getAssignableApiUrl }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`${getAssignableApiUrl}/${id}/approvables`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updateApprover(_, { data, id, editApiUrl }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`${editApiUrl}/${id}`, data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  handleSizeChangeApprover(
    { commit, dispatch },
    { perPageApprover, getApiUrl }
  ) {
    commit("perPageApprover", perPageApprover);
    commit("pageApprover", 1);
    dispatch("getAllApprovers", getApiUrl);
  },

  handleCurrentChangeApprover(
    { commit, dispatch },
    { pageApprover, getApiUrl }
  ) {
    commit("pageApprover", pageApprover);
    dispatch("getAllApprovers", getApiUrl);
  },
};
